import React from 'react';

import {BtnBlueFilled} from "../../../Buttons";
import {Tooltip} from "@material-ui/core";

const submitBtnCtor = (BtnComponent) => ({children, formCtx, changesCheckDisabled, disabled}) => {
  const formState = (formCtx || {}).state || {};
  const click = formState.click;
  const isLoading = formState.loading;

  const noChanges = !changesCheckDisabled && !formState.hasChanges;
  const numberOfErrors = Object.keys(formState.errors || {}).length;

  const disabledByFormCtx = noChanges || (click && numberOfErrors);
  const btnDisabled = !!(disabled || isLoading || disabledByFormCtx);
  //const disabledByFormCtx = false;

  const btn = (
      <BtnComponent type="submit" disabled={btnDisabled} loading={isLoading}>
        {children}
      </BtnComponent>
  );

  return disabledByFormCtx ? (
    <Tooltip
      placement="top"
      title={
        noChanges
          ? 'Make some changes to enable button'
          : numberOfErrors
            ? `There is still some (${numberOfErrors}) errors left in form`
            : ''
      }
    >
      <div>
        {btn}
      </div>
    </Tooltip>
  ) : (
    btn
  )
}

export const SubmitBtnMerchant = submitBtnCtor(BtnBlueFilled);
